import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { DesignateStationComponent } from '../designate-station/designate-station.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { QBuiltSharedInspService } from '../services/qbuilt-shared.service';
import { CommonModule } from '@angular/common';
import {MatSelectModule} from '@angular/material/select';

@Component({
    selector: 'defect-form',
    imports: [
        MatProgressSpinnerModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIcon,
        MatCheckboxModule,
        MatProgressBarModule,
        MatIconModule,
        DesignateStationComponent,
        ReactiveFormsModule,
        MatExpansionModule,
        CommonModule,
        MatSelectModule
    ],
    templateUrl: './defect-form.component.html',
    styleUrl: './defect-form.component.scss'
})


export class DefectFormComponent {
  //session storage keys
  defectItemsKey: string = this.qbuiltInspConstants.defectItemsKey;
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;

  @Input() defect: any;
  @Input() element: any;
  @Input() prepopulatedValues: any;
  @Input() departments: any[] = [];
  @Input() locations: any[] = [];
  @Output() emitCompleteDefect = new EventEmitter<any>();
  @Output() emitLocationChange = new EventEmitter<any>();
  @Output() emitQuantityChange = new EventEmitter<any>();
  @Output() emitDescChange = new EventEmitter<any>();
  @Output() emitDesignateDefect = new EventEmitter<any>();
  @Output() emitRemoveDefect = new EventEmitter<any>();
  @Output() emitInZoneDefect = new EventEmitter<any>();

  loading: boolean = false;

  emptyStationList: boolean = false;

  locationSelection: string = 'Location';
  locationLabel: string = this.qbuiltInspConstants.locationLabel;
  locationPlaceholder: string = this.qbuiltInspConstants.locationPlaceholder;

  //defect text
  quantityLabel: string = this.qbuiltInspConstants.defectQuantityLabel;
  defectDescLabel: string = this.qbuiltInspConstants.defectDescLabel;
  addAdditionalDefectText: string = this.qbuiltInspConstants.addAdditionalDefectText;
  attachPhotosLabel: string = this.qbuiltInspConstants.attachPhotosLabel;
  defectTitle: string = this.qbuiltInspConstants.defectColumn;
  
  //designate to another station
  enableDesignation: boolean = false;
  defectDesignationComplete: boolean = false;

  defectFormGroup: FormGroup = new FormGroup({
    defectId: new FormControl(Validators.required),
    departmentId: new FormControl([''], Validators.required),
    locationId: new FormControl(null, Validators.required),
    quantity: new FormControl(1, Validators.min(1)),
    defectDesc: new FormControl(''),
    designateStation: new FormControl(false),
    stationId: new FormControl(0),
    stationName: new FormControl(''),
    statusId: new FormControl(1) 
  });
  
  defectList: any[] = [];
  defectFormList: any[] = [];
  descValue: string = '';
  defectId: number = 0;

  fixedText: string = this.qbuiltInspConstants.fixedColumn;
  sentText: string = this.qbuiltInspConstants.SentText;

  stationIdList: any[] = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').stationIdList || [];

  cqmsDefectItems: any;

  constructor(
    private qbuiltInspConstants: QBuiltInspectorConstants,
  ) { }

  ngOnInit() {
    this.loading = true;
    this.cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
    this.populateForm();
    this.cqmsDefectItems = {...this.cqmsDefectItems, defectList: this.defectList};
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(this.cqmsDefectItems));
    this.defectList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];
  }

  defectCheck(defect  : any) {
    if(defect.statusId === 3) {
      return true;
    } else {
      return false;
    }
  }

  //Manages whether or not the 'x' icon appears for the individual defect depending on the defect count
  //disappears if there is only one defect under a task item
  defectLengthCheck(element: any) {
    let defectTasks = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];
    let checkList: any[] = [];
    defectTasks.forEach((defect: any) => {
      if(defect.TaskId === element.TaskId && defect.IsDeleted === false) {
        checkList.push(defect);
      }
    });

    if(checkList.length > 1) {
      return true; 
    } else {
      return false; 
    }
  }

  populateForm() {
    //get defect id and defect list
    this.defectId = this.defect.Id;
    this.defectList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectList || [];
   
    //get defect form list but pull out the defect form specific to the defect id
    this.defectFormList = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectFormList || [];
    let defectForm = this.defectFormList.find(d => d.defectId === this.defect.Id);
    //set all the values including location name
    if(defectForm) {
      this.locationSelection = this.locations.filter(loc => loc.Id === defectForm.locationId)[0]?.Name || 'Location';
      this.defectFormGroup.setValue({
        defectId: this.defect.Id,
        departmentId: defectForm.departmentId ? defectForm.departmentId : '',
        locationId: defectForm.locationId ? defectForm.locationId : null,
        quantity: defectForm.quantity ? defectForm.quantity : 1,
        defectDesc: defectForm.defectDesc ? defectForm.defectDesc : '',
        designateStation: defectForm.designateStation ? defectForm.designateStation : false,
        stationName: defectForm.stationName ? defectForm.stationName : '',
        stationId: defectForm.stationId ? defectForm.stationId : 0,
        statusId: defectForm.statusId ? defectForm.statusId : 1
      });
      this.enableDesignation = this.defectFormGroup.valid ? true : false;
    }
    if(defectForm?.statusId === 3 || defectForm?.statusId === 2) {
      this.defectFormGroup.disable();
      this.defectFormGroup.invalid;
    }
    this.loading = false;
  }

  //TODO -- disable already used locations within the same task item 
  onLocationChange(event: any) {
    this.locationSelection = this.locations.filter(loc => loc.Id === event.value)[0].Name;
    this.defectFormGroup.get('locationId').setValue(event.value);
    this.defectList.filter(d => d.Id === this.defect.Id).forEach(d => d.LocationId = event.value);
    let updatedDefect = this.defectList.find(d => d.Id === this.defect.Id);
    this.updateFormGroup(this.defectFormGroup);
    this.emitLocationChange.emit(updatedDefect);
  }

  addDefectDesc(event: any) {
    this.defectList.filter(d => d.Id === this.defect.Id).forEach(d => d.Description = event.target.value);
    this.defectFormGroup.get('defectDesc').setValue(event.target.value);
    let updatedDefect = this.defectList.find(d => d.Id === this.defect.Id);
    this.updateFormGroup(this.defectFormGroup);
    this.emitDescChange.emit(updatedDefect);
  }

  //Add Photo to defect -- WILL BE ADDED BACK IN LATER
  // addPhoto() {
  //   console.log('addphoto clicked');
  //   //open photo attach modal
  //   const dialogRef = this.qbuiltDialog.openInspectorDialog(2);
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if(result) {
  //       console.log('photo dialog result', result);
  //     }
  //   });
  // }

  onDesignationTriggered($event: any) {
    this.defectFormGroup.get('designateStation').setValue(true);
    this.defectFormGroup.get('stationName').setValue($event.Name);
    this.defectFormGroup.get('stationId').setValue($event.Id);
    this.defectFormGroup.get('statusId').setValue(2);
    this.updateFormGroup(this.defectFormGroup);
    this.defectFormGroup.disable();

    this.emitDesignateDefect.emit(this.defectFormGroup.value);
  }

  fixDefect($event: any) {
    this.defectFormGroup.get('statusId').setValue(3);
    this.updateFormGroup(this.defectFormGroup);
    this.defectFormGroup.disable();
    this.emitCompleteDefect.emit($event);
  }

  //Add and subtract from quanity
  changeQuantity(value: number, action: string) {
    if(action === 'add') {
      this.defectFormGroup.get('quantity').setValue(value + 1);
    } else if(action === 'subtract' && value > 0) {
      this.defectFormGroup.get('quantity').setValue(value - 1);
    } else if (action === 'custom' && value === null) {
      this.defectFormGroup.get('quantity').setValue(0);
    }

    this.updateFormGroup(this.defectFormGroup);
    this.defectList.filter(d => d.Id === this.defect.Id).forEach(d => d.DefectQuantity = this.defectFormGroup.get('quantity').value);
    
    let updatedDefect = this.defectList.find(d => d.Id === this.defect.Id);
    this.emitQuantityChange.emit(updatedDefect);
  }

updateFormGroup(defectFormGroup: FormGroup) {
  //reset current station on change
  let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
  cqmsSessionItems.currentStationId = this.defect.StationId;
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));

  const updated = defectFormGroup.value;
  const defectFormList: any[] = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}').defectFormList || [];

  defectFormList.forEach((d: any) => {
    if (d.defectId === updated.defectId) {
      d.departmentId = updated.departmentId;
      d.locationId = updated.locationId;
      d.quantity = updated.quantity;
      d.defectDesc = updated.defectDesc;
      d.designateStation = updated.designateStation;
      d.stationName = updated.stationName;
      d.stationId = updated.stationId;
      d.statusId = updated.statusId;
    }
  });

  const cqmsDefectItems = sessionStorage.getItem(this.defectItemsKey) ? JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}') : {};
  cqmsDefectItems.defectFormList = defectFormList;
  sessionStorage.setItem(this.defectItemsKey, JSON.stringify(cqmsDefectItems));
  this.enableDesignation = defectFormGroup.valid;
}

  //passes boolean to enable or disable form fields
  formCheck() {
    if(this.defectFormGroup.get('statusId').value === 2) {
      return true;
    } else {
      return false;
    }
  }

  //hides the station content if the defect is marked as fixed or has already been designated to another station
  //statuses 3 or 2
  closedDefect() {
    if(this.defectFormGroup.get('statusId').value === 3 || this.defectFormGroup.get('statusId').value === 2) {
      return false;
    } else {
      return true;
    }
  }

  //Removed Individual Defect from defect panel
  removeDefect($event: any) {
    this.emitRemoveDefect.emit($event);
  }

  //get station name from station id
  //TODO -- to be used later
  // getStationName() {
  //   console.log('defect form value', this.defectFormGroup.value);
  //   let stationList = sessionStorage.getItem('facilityStationList') ? JSON.parse(sessionStorage.getItem('facilityStationList')) : [];
  //   console.log('station list', stationList);
  //   let stationName = this.defectFormGroup.get('stationName').value;
  //   console.log('station name', stationName);
  //   if(!stationName || stationName === '') {
  //     stationName = stationList.filter((s: Location) => s.Id === this.defectFormGroup.get('stationId').value);
  //     console.log('station name after cahnge', stationName);
  //   }
  //   return stationName;
  // }
}